'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.typeOf = exports.generateCurrencyRegex = exports.regexCreator = exports.checkForLeftSideLength = exports.checkDecimalAgainstMaxLength = exports.generateMaxLength = exports.checkForOneNegativeAtProperLocation = exports.checkforOneDecimalAndMaxDecimalUnits = exports.checkForOneDecimal = exports.undesirableCurrencyFieldStates = exports.checkAcceptableChangeState = exports.checkNextPropsWhileNotTyping = exports.formatToAFloat = exports.convertNegativeToProperDash = exports.convertDecimalToPeriod = exports.removeThousands = undefined;

var _PolyFillFunctions = require('./PolyFillFunctions');

/**
 * Remove the thousands seperator from a string and return the modified string
 * @param value the value with a thousands separator
 * @param thousands the thousands separator
 */
var removeThousands = exports.removeThousands = function removeThousands(value, thousands) {
	return value.split(thousands).join("");
};

var convertDecimalToPeriod = exports.convertDecimalToPeriod = function convertDecimalToPeriod(value, decimal) {
	return value.replace(decimal, '.');
};

var convertNegativeToProperDash = exports.convertNegativeToProperDash = function convertNegativeToProperDash(value, negative) {
	return value.replace(negative, "-");
};

var formatToAFloat = exports.formatToAFloat = function formatToAFloat(value, thousands, decimal, negative) {
	var temp = void 0;

	temp = removeThousands(value, thousands);

	temp = convertDecimalToPeriod(temp, decimal);
	temp = convertNegativeToProperDash(temp, negative);

	return parseFloat(temp);
};

var checkNextPropsWhileNotTyping = exports.checkNextPropsWhileNotTyping = function checkNextPropsWhileNotTyping(value, hasFocusOrIsTyping) {
	if ((value || value === '' || value === 0) && !hasFocusOrIsTyping) {
		return true;
	} else {
		return false;
	}
};

var checkAcceptableChangeState = exports.checkAcceptableChangeState = function checkAcceptableChangeState(value, negative, decimal) {
	if (value === '' || value === negative || value === negative + decimal || value === decimal) {
		return true;
	} else {
		return false;
	}
};

var undesirableCurrencyFieldStates = exports.undesirableCurrencyFieldStates = function undesirableCurrencyFieldStates(value, negative, decimal) {
	if (value === negative + negative || value === negative + decimal + decimal || value === decimal + negative || value === decimal + decimal || value === negative + decimal + negative) {
		return true;
	} else {
		return false;
	}
};

var checkForOneDecimal = exports.checkForOneDecimal = function checkForOneDecimal(value, decimal) {
	if ((0, _PolyFillFunctions.Includes)(value, decimal)) {
		if (value.match(new RegExp("[" + decimal + "]", "g")).length !== 1) {
			return true;
		}
	}
	return false;
};

var checkforOneDecimalAndMaxDecimalUnits = exports.checkforOneDecimalAndMaxDecimalUnits = function checkforOneDecimalAndMaxDecimalUnits(value, decimal, maxUnits) {
	if ((0, _PolyFillFunctions.Includes)(value, decimal)) {
		if (value.substring(value.indexOf(decimal)).length > maxUnits + 1 || value.match(new RegExp("[" + decimal + "]", "g")).length !== 1) {
			return true;
		}
	}
	return false;
};

var checkForOneNegativeAtProperLocation = exports.checkForOneNegativeAtProperLocation = function checkForOneNegativeAtProperLocation(value, negative, negativeAtStart) {
	if ((0, _PolyFillFunctions.Includes)(value, negative)) {
		if (value.match(new RegExp("[-" + negative + "]", "g")).length !== 1 || value.substring(0, 1) !== negative && negativeAtStart || value.substring(value.length - 1) !== negative && !negativeAtStart) {
			return true;
		}
	}
	return false;
};

/**
  * Get the max characters allowed.
  */
var generateMaxLength = exports.generateMaxLength = function generateMaxLength(value, maxLength, decimal, maxDecimalUnits) {
	if (maxLength > 16) {
		maxLength = 16;
	}
	var standardLength = 13;
	var decimalUnits = maxDecimalUnits ? maxDecimalUnits + 1 : 0;
	var includesDecimal = decimal && value ? (0, _PolyFillFunctions.Includes)(value, decimal) : false;
	var length = maxLength ? maxLength : standardLength;

	if (includesDecimal) {
		return length + decimalUnits;
	} else {
		return length + 1;
	}
};

var checkDecimalAgainstMaxLength = exports.checkDecimalAgainstMaxLength = function checkDecimalAgainstMaxLength(value, decimal, maxLength) {
	if (value && decimal) {
		if (value.length >= maxLength) {
			return (0, _PolyFillFunctions.Includes)(value, decimal);
		}
	}
	return true;
};

var checkForLeftSideLength = exports.checkForLeftSideLength = function checkForLeftSideLength(value, maxLength, decimal) {
	var temp = value;
	if ((0, _PolyFillFunctions.Includes)(value, decimal)) {
		temp = value.substring(0, value.indexOf(decimal));
	}
	if (temp.length > maxLength) {
		return false;
	}
	return true;
};

var regexCreator = exports.regexCreator = function regexCreator(negative, decimal, thousands) {
	var baseRegex = '^([\b^0-9' + thousands + '.' + negative + '])*$';
	return baseRegex.replace(".", decimal);
};

/**
* Generate a regex that will only allow numbers, backspace, and the decimal separator
* This will be used to exclude any keystrokes outside of this scope.
*/
var generateCurrencyRegex = exports.generateCurrencyRegex = function generateCurrencyRegex(negative, decimal) {
	var baseRegex = '^([\b0-9.' + negative + '])*$';
	return baseRegex.split(".").join(decimal);
};

//can return Object, String, Number, Boolean, Null and Undefined
var typeOf = exports.typeOf = function typeOf(value) {
	return Object.prototype.toString.call(value).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/utils/NumberUtils.js
// module id = 383
// module chunks = 10